import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendCard = ({ trend }) => {
  const getImpactColor = (impact) => {
    switch (impact) {
      case 'positive': return 'success';
      case 'negative': return 'error';
      case 'neutral': return 'muted';
      default: return 'muted';
    }
  };

  const getImpactIcon = (impact) => {
    switch (impact) {
      case 'positive': return 'TrendingUp';
      case 'negative': return 'TrendingDown';
      case 'neutral': return 'Minus';
      default: return 'Minus';
    }
  };

  return (
    <div className="p-3 bg-muted/30 rounded-lg border border-border hover:border-primary/50 transition-smooth">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-start gap-2 flex-1">
          <Icon 
            name={getImpactIcon(trend?.impact)} 
            size={16} 
            color={`var(--color-${getImpactColor(trend?.impact)})`}
            className="mt-0.5 flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <h4 className="font-body font-semibold text-sm text-foreground mb-1">
              {trend?.category}
            </h4>
            <p className="caption text-muted-foreground">
              {trend?.description}
            </p>
          </div>
        </div>
        {trend?.confidence && (
          <span className={`
            px-2 py-0.5 rounded text-xs font-medium flex-shrink-0
            ${trend?.confidence === 'high' ? 'bg-success/10 text-success' : ''}
            ${trend?.confidence === 'medium' ? 'bg-warning/10 text-warning' : ''}
            ${trend?.confidence === 'low' ? 'bg-muted text-muted-foreground' : ''}
          `}>
            {trend?.confidence}
          </span>
        )}
      </div>
    </div>
  );
};

export default TrendCard;
